import {type Type, Plugins} from '@packages/systems/wfdl';
import {typeName, qualify} from '@packages/systems/wfdl-Qualified';
export const migrateTextDataType = (dataTypeJson: any) => {
  if (dataTypeJson && dataTypeJson.type === 'Text') {
    const newDataType: Type = {
      type: 'TypeConstructor',
      val: qualify(Plugins.name('Builtin'), typeName('Text')),
    };

    if (dataTypeJson.system) newDataType.system = dataTypeJson.system;
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};
